var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-form-footer-content",class:[{
    'k-form-footer-align-left': _vm.dataAlign === 'left',
    'k-form-footer-align-center': _vm.dataAlign === 'center',
    'k-form-footer-align-right': _vm.dataAlign === 'right',
    'k-form-footer-align-default': !_vm.dataAlign
  }]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26294a2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/k-element/k-from/k-form-footer.vue
// module id = null
// module chunks = 